import './styles/index.scss';
import './image-lazy-load';

import './cart';
import './cart-notification';

import './details-disclosure';
import './details-modal';

import './shopify-global';
import '../lib/upsell-cart';

import { onDocumentReady } from '../utils/dom';
import initCartDrawer from './cart-drawer';
import initSearchbar from './search-bar';
import initCssVariables from './css-variables';
import initDynamicFreeShipping from './dynamic-free-shipping';
import { formSubmitPreventer } from './wishlist';
import init from './menu-drawer';
import initProductQuickView from './quick-view';
import initShopModal from './shop-modal';
import initPDPCollapsible from './pdp-collapsible'
import initProductCardSelectA11y from './product-card-select-a11y'

onDocumentReady(
  () => (
    init(),
    initCartDrawer(),
    initSearchbar(),
    initCssVariables(),
    initDynamicFreeShipping(),
    formSubmitPreventer(),
    initProductQuickView(),
    initShopModal(),
    initPDPCollapsible(),
    initProductCardSelectA11y()
  )
);
